import { render, staticRenderFns } from "./CPageNewsIndexStandard.vue?vue&type=template&id=6d366379&"
import script from "./CPageNewsIndexStandard.vue?vue&type=script&lang=ts&"
export * from "./CPageNewsIndexStandard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports